import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Spin } from 'antd';
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { FormCard, FormPageContainer, FormPageHeader } from '@/components/PageLayout';
import { useHeroSlides } from '@/hooks/useHeroSlideQueries';
import { useListReturn } from '@/hooks/useListReturn';
import { ROUTES } from '@/routes/routes';

import { EditHeroSlideForm } from './EditHeroSlideForm';

export const EditHeroSlidePage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { goToList } = useListReturn(ROUTES.HERO_SLIDES);
  const { data: slides, isLoading } = useHeroSlides();

  if (isLoading) {
    return (
      <FormPageContainer>
        <Spin size="large" style={{ margin: 'auto' }} />
      </FormPageContainer>
    );
  }

  const slide = slides?.find((s) => s.id === Number(id));

  if (!slide) {
    return <Navigate to={ROUTES.HERO_SLIDES} />;
  }

  return (
    <FormPageContainer>
      <FormPageHeader>
        <Button type="text" icon={<ArrowLeftOutlined />} onClick={goToList} />
        <h2>Редагувати слайд</h2>
      </FormPageHeader>
      <FormCard>
        <EditHeroSlideForm slide={slide} />
      </FormCard>
    </FormPageContainer>
  );
};
